export const getHasUserScope = (userInfo, scope) => userInfo.user.scopes.includes(scope);